import { BlockType } from '../../types/index.js';
import { ToggleBlock as Component } from './Block.js';
export const RegisteredToggleBlock = (_intl) => ({
    recommendedName: 'Toggle',
    Component,
    config: {
        type: BlockType.BuildingBlock,
        defaultProps: {
            showChildrenOnEnabled: true,
        },
    },
});
//# sourceMappingURL=registered.js.map